import React, { useEffect } from 'react';
import PequeninLogoPWA from '../../../assets/images/logo/pequenin-logo-pwa.png';
import { localStorage } from '../../../utils/storage';
import Button from '../../atoms/button/button';
import IOSPWAInstallationModal from '../ios-pwa-installation-modal/ios-pwa-installation-modal';
import './pwa-installation-modal.scss';

const PWAInstallationModal = ({ deferredPrompt, setActiveModal }) => {

    useEffect(() => {
        document.documentElement.style.overflowY = 'hidden';
        document.body.scroll = "no";
        return () => {
            document.documentElement.style.overflowY = 'scroll';
            document.body.scroll = "yes";
        }
    }, [])

    const isIOS = !!navigator.platform && /iPhone/.test(navigator.platform)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

    const installPWA = () => {
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
            setActiveModal(null)
            localStorage.setItem("PWA_VISUALIZATION", "denied")
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt');
            } else {
                console.log('User dismissed the A2HS prompt');
            }
        });
    }

    return (
        <div className="f-m-pwa-installation-modal">
            <div className="f-m-pwa-installation-modal__content">
                <div className="f-m-pwa-installation-modal__background"></div>
                <div className="f-m-pwa-installation-modal__close"
                    onClick={() => {
                        const pwaVisualization = localStorage.getItem("PWA_VISUALIZATION")
                        localStorage.setItem("PWA_VISUALIZATION", (pwaVisualization >= 2 ? "denied" : pwaVisualization + 1))
                        setActiveModal(null)
                    }}
                >
                    x
                </div>
                <img
                    src={PequeninLogoPWA}
                    alt="pwa-logo"
                    className="f-m-pwa-installation-modal__logo"
                    loading="lazy"
                />
                <div className="f-m-pwa-installation-modal__text">
                    <h3 className="f-m-pwa-installation-modal__title">¿Quieres llevar el contenido de Pequeñín en tu celular?</h3>
                    <p className="f-m-pwa-installation-modal__description">Si aceptas se creará un acceso directo en la pantalla para que ingreses cuando quieras.</p>
                </div>
                <div className="f-m-pwa-installation-modal__buttons-container">
                    <Button
                        id="f-a-button__pwa-installation-modal"
                        className={"f-a-button__primary-purple f-a-button__big f-m-pwa-installation-modal__button-accept"}
                        copy={(isIOS && isSafari) ? "Continuar" : "¡Crear acceso directo!"}
                        onclick={() => {

                            if (isIOS && isSafari) {
                                setActiveModal(
                                    <IOSPWAInstallationModal
                                        setActiveModal={setActiveModal}
                                    />
                                )

                            } else {
                                installPWA()
                            }

                        }}
                    />
                    <div className="f-m-pwa-installation-modal__decline"
                        onClick={() => {
                            const pwaVisualization = localStorage.getItem("PWA_VISUALIZATION")
                            localStorage.setItem("PWA_VISUALIZATION", (pwaVisualization >= 2 ? "denied" : pwaVisualization + 1))
                            setActiveModal(null)
                        }}
                    >
                        No, en otro momento
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PWAInstallationModal
